import type { Product } from 'product/types/Product'
import { useCartDispatch } from '../context/CartProvider'
import type { ItemDto } from '../services/graphql.types'
import type { CartProduct } from '../types/CartProduct'
import { buildCartProduct } from '../utils/productMappers'
import { useGetProductInfo } from './queries/useGetProductInfo'
import { useGetProductStock } from './queries/useGetProductStock'
import { useNotifications } from './useNotifications'

export const useCartProduct = (
	item: ItemDto
): {
	cartProduct: CartProduct | null
	productInfo: Product | null
	isLoading: boolean
} => {
	const {
		productInfo,
		error: productInfoError,
		isLoading: infoLoading,
	} = useGetProductInfo(item?.productId)

	const {
		productStock,
		error: productStockError,
		isLoading: stockLoading,
	} = useGetProductStock(item?.productId)
	const { itemWithParamErrorNotification } = useNotifications()
	const dispatch = useCartDispatch()

	if (productInfoError || productStockError) {
		itemWithParamErrorNotification()
		dispatch({ visibleItemErrorBanner: true })
		return { cartProduct: null, isLoading: false, productInfo: null }
	}

	if (infoLoading || stockLoading || !productInfo || !productStock) {
		return { cartProduct: null, isLoading: true, productInfo: null }
	}

	const cartProduct = buildCartProduct(item, productInfo, productStock)

	return { cartProduct, productInfo, isLoading: false }
}
